export default "__VITE_ASSET__B0CB9S_C__"